import { render, staticRenderFns } from "./license-buy.vue?vue&type=template&id=399b0251&scoped=true&"
import script from "./license-buy.vue?vue&type=script&lang=ts&"
export * from "./license-buy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399b0251",
  null
  
)

export default component.exports